module.exports = __webpack_public_path__ + "img/SL-M-120-200.aabd914b.svg";